module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabs is-centered"
  }, [_c('ul', [_c('li', {
    class: {
      'is-active': _vm.currentStep === 1
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-heartbeat"
  }), _vm._v(" " + _vm._s(_vm.currentStep === 1 ? 'Connection' : ''))])]), _vm._v(" "), _c('li', {
    class: {
      'is-active': _vm.currentStep === 2
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-info"
  }), _vm._v(" " + _vm._s(_vm.currentStep === 2 ? 'Information' : ''))])]), _vm._v(" "), _c('li', {
    class: {
      'is-active': _vm.currentStep === 3
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-wifi"
  }), _vm._v(" " + _vm._s(_vm.currentStep === 3 ? 'Wi-Fi' : ''))])]), _vm._v(" "), _c('li', {
    class: {
      'is-active': _vm.currentStep === 4
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-signal"
  }), _vm._v(" " + _vm._s(_vm.currentStep === 4 ? 'MQTT' : ''))])]), _vm._v(" "), _c('li', {
    class: {
      'is-active': _vm.currentStep === 5
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-cogs"
  }), _vm._v(" " + _vm._s(_vm.currentStep === 5 ? 'Settings' : ''))])]), _vm._v(" "), _c('li', {
    class: {
      'is-active': _vm.currentStep === 6
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-rocket"
  }), _vm._v(" " + _vm._s(_vm.currentStep === 6 ? 'Launch' : ''))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dd07b324"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProgressBar.vue
// module id = 61
// module chunks = 0